import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

export interface RemoveUserDialogData {
  title?: string;
  message?: string;
}

@Component({
  selector: 'app-remove-user-dialog',
  // Inline template to avoid templateUrl resolution issues
  templateUrl: './remove-user-dialog.component.html',
  styleUrls: ['./remove-user-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule],
})
export class RemoveUserDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<RemoveUserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RemoveUserDialogData,
  ) {
    try {
      console.debug('[RemoveUserDialog] ctor, data=', data);
    } catch {}
  }

  unassign() {
    this.dialogRef.close('unassign');
  }
  deleteNode() {
    this.dialogRef.close('delete');
  }
  cancel() {
    this.dialogRef.close();
  }
}
